<template>
    <div class="splash">
        <div class="splash__logo">
            <publisher-icon :icon-name="'IconAuthorization'" />
        </div>
        <common-icon class="splash__error-logo" :icon-name="'IconNotSupported'" />
        <div v-if="messageText" class="splash__error">{{ messageText }}</div>
        <button
            ref="btn"
            class="btn"
            @click="closeApp"
        >
            {{ btnCaption }}
        </button>
    </div>
</template>

<script setup lang="ts">
    import { Strings } from "@/locales/types/enums/strings";
    import { useI18n } from "vue-i18n";
    import { useRoute } from 'vue-router';
    import { useAccountStore } from "@/stores/Account";
    import { AppConstants} from "@/common";

    const AccountStoreModule = useAccountStore();
    const { getErrorMessage } = AccountStoreModule;

    const props = defineProps<{
        errorCode?: string;
    }>();

    const { t } = useI18n();
    const route = useRoute();
    const btnCaption: string = t(Strings.ERROR_BTN).toString();
    const btn: Ref<HTMLButtonElement | null> = ref(null);

    const messageText = computed((): string => route?.query?.errorMessage as string ?? getErrorMessage(props.errorCode ?? route?.query?.errorCode as string ?? "DEFAULT"));

    const closeApp = (): void => {
        localStorage.setItem(AppConstants.keyCacheBrowser, '0');
        window.close();
    };

    onMounted(() => {
        if (btn.value) {
            btn.value.focus();
        }
    });
</script>
